var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transportation",
    transform: "translate(-160 -56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 96,
    height: 96,
    rx: 48,
    transform: "translate(160 56)",
    fill: "#f0edf5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Transportation-2",
    "data-name": "Transportation",
    transform: "translate(187 88)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 24.438,
    height: 2.16,
    transform: "translate(9.105 8.642)",
    fill: "#6a55a0",
    stroke: "#6a55a0",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10274",
    "data-name": "Path 10274",
    d: "M31.788,0H10.86A2.833,2.833,0,0,0,8,2.787V26.92a2.833,2.833,0,0,0,2.86,2.787H31.788a2.833,2.833,0,0,0,2.871-2.787V2.787A2.833,2.833,0,0,0,31.788,0Zm.65,26.92a.618.618,0,0,1-.191.445.654.654,0,0,1-.459.182H10.86a.635.635,0,0,1-.639-.627V2.787a.635.635,0,0,1,.639-.627H31.788a.654.654,0,0,1,.459.182.618.618,0,0,1,.191.445Z",
    transform: "translate(0 0)",
    fill: "#6a55a0",
    stroke: "#6a55a0",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 8.886,
    height: 2.16,
    transform: "translate(16.881 4.321)",
    fill: "#6a55a0",
    stroke: "#6a55a0",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 24.438,
    height: 2.16,
    transform: "translate(9.105 19.444)",
    fill: "#6a55a0",
    stroke: "#6a55a0",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10277",
    "data-name": "Path 10277",
    d: "M32.762,46.16h-.206a.992.992,0,0,1-1.005-.978v-.2a.964.964,0,0,1,.292-.695A1.02,1.02,0,0,1,32.556,44h.206a1.02,1.02,0,0,1,.716.286.964.964,0,0,1,.294.7v.2a.964.964,0,0,1-.3.693,1.02,1.02,0,0,1-.714.284Zm-15.551,0h-.205A.992.992,0,0,1,16,45.183v-.2a.964.964,0,0,1,.292-.695A1.02,1.02,0,0,1,17.005,44h.205a1.02,1.02,0,0,1,.716.286.964.964,0,0,1,.294.7v.2a.964.964,0,0,1-.3.693A1.02,1.02,0,0,1,17.211,46.16Z",
    transform: "translate(-3.557 -20.235)",
    fill: "#6a55a0",
    stroke: "#6a55a0",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10278",
    "data-name": "Path 10278",
    d: "M.007.009,4.461,0,4.454,3.4,0,3.407Z",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, 10.499, 28.29)",
    fill: "#6a55a0",
    stroke: "#6a55a0",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10279",
    "data-name": "Path 10279",
    d: "M0,0,4.454.009l.007,3.4L.007,3.4Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 32.679, 31.689)",
    fill: "#6a55a0",
    stroke: "#6a55a0",
    strokeWidth: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportation);
export default __webpack_public_path__ + "static/media/Transportation.326e5296c39c9beca54719892f76913d.svg";
export { ForwardRef as ReactComponent };